import { AppError } from "config/errors";
import { translationsQuery } from "gql/queries/translations";
import { ITranslations } from "store/reducers/translations";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchTranslations = createAsyncThunk(
  "fetchTranslations",
  async (_, { rejectWithValue }) => {
    try {
      const res = await translationsQuery();

      const translations = res.data.translations.reduce((map: ITranslations, term) => {
        map[term.key] = term.value;
        return map;
      }, {});

      return translations;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);
